export default '/static/images/logos/logo-acuitis.svg';
